import { Model } from '@/models/Model'
import Property from '@/decorators/Property'
import { ToOneRelation } from 'coloquent/dist/relation/ToOneRelation'
import { Transport } from '@/models/Transport'
import User from '@/models/User'
import { Vessel } from '@/models/Vessel'
import { Terminal } from '@/models/Terminal'
import { CargoType } from '@/models/CargoType'
import { Company } from '@/models/Company'
import { GeoJSON } from 'geojson'

export class BillOfLadingTransport extends Model {
	protected jsonApiType = 'billOfLadingTransports'

	@Property()
	public documentNumber!: string

	@Property()
	public generatedAt!: string

	@Property()
	public issueLocation!: string

	@Property()
	public declarationShipper!: string

	@Property()
	public instructionsShipper!: string

	@Property()
	public companyName!: string

	@Property()
	public remark!: string

	@Property()
	public customProduct!: string

	@Property()
	public quantity!: string

	@Property()
	public quantityUnit!: string

	@Property()
	public customStartAddress!: string | null

	@Property()
	public customStartCountryCode!: string | null

	@Property()
	public customStartGeometry!: string | GeoJSON.Point | null

	@Property()
	public customDestinationAddress!: string | null

	@Property()
	public customDestinationCountryCode!: string | null

	@Property()
	public customDestinationGeometry!: string | GeoJSON.Point | null

	private transport(): ToOneRelation {
		return this.hasOne(Transport, 'transport')
	}

	public getTransport(): Transport {
		return this.getRelation('transport')
	}

	public setTransport(transport: Transport): void {
		this.setRelation('transport', transport)
	}

	private creator(): ToOneRelation {
		return this.hasOne(User, 'creator')
	}

	public getCreator(): User {
		return this.getRelation('creator')
	}

	private shipper(): ToOneRelation {
		return this.hasOne(Company, 'shipper')
	}

	public getShipper(): Company {
		return this.getRelation('shipper')
	}

	public setShipper(shipper: Company) {
		this.setRelation('shipper', shipper)
	}

	private carrier(): ToOneRelation {
		return this.hasOne(Company, 'carrier')
	}

	public getCarrier(): Company {
		return this.getRelation('carrier')
	}

	public setCarrier(carrier: Company) {
		this.setRelation('carrier', carrier)
	}

	private vessel(): ToOneRelation {
		return this.hasOne(Vessel, 'vessel')
	}

	public getVessel(): Vessel {
		return this.getRelation('vessel')
	}

	public setVessel(vessel: Vessel) {
		this.setRelation('vessel', vessel)
	}

	private unregisteredVessel(): ToOneRelation {
		return this.hasOne(Vessel, 'unregisteredVessel')
	}

	public getUnregisteredVessel(): Vessel {
		return this.getRelation('unregisteredVessel')
	}

	public setUnregisteredVessel(vessel: Vessel) {
		this.setRelation('unregisteredVessel', vessel)
	}

	private cargoType(): ToOneRelation {
		return this.hasOne(CargoType, 'cargoType')
	}

	public getCargoType(): CargoType {
		return this.getRelation('cargoType')
	}

	public setCargoType(cargoType: CargoType) {
		this.setRelation('cargoType', cargoType)
	}

	public startTerminal(): ToOneRelation {
		return this.hasOne(Terminal, 'startTerminal')
	}

	public getStartTerminal(): Terminal {
		return this.getRelation('startTerminal')
	}

	public setStartTerminal(terminal: Terminal | null): void {
		return this.setRelation('startTerminal', terminal)
	}

	public destinationTerminal(): ToOneRelation {
		return this.hasOne(Terminal, 'destinationTerminal')
	}

	public getDestinationTerminal(): Terminal {
		return this.getRelation('destinationTerminal')
	}

	public setDestinationTerminal(terminal: Terminal | null): void {
		return this.setRelation('destinationTerminal', terminal)
	}
}
